module.exports = __webpack_public_path__ + "static/media/slide01.47301963.jpg";